/**
 * InsiStatusOnSave — the "Status on save: <chip>" row shown in the create/edit
 * dialogs so the PS sees the reliability status the current action will produce.
 * Centralises the chip variant + label so the two dialogs don't each hardcode
 * the QUALIFIEE / RECUPEREE / PROVISOIRE mapping.
 */
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box as MuiBox, Typography } from '@mui/material';

import StatusChip from 'components/ui/StatusChip';
import { INSI_STATUS_LABEL, INSI_STATUS_CHIP_VARIANT } from './insiStatus';

export default function InsiStatusOnSave({ status }) {
  const { t } = useTranslation();
  if (!status || !INSI_STATUS_LABEL[status]) return null;

  return (
    <MuiBox
      display="flex"
      alignItems="center"
      gap="8px"
      data-id="insi-status-on-save"
    >
      <Typography variant="body2">{t('Status on save')}:</Typography>
      <StatusChip status={INSI_STATUS_CHIP_VARIANT[status]}>
        {t(INSI_STATUS_LABEL[status])}
      </StatusChip>
    </MuiBox>
  );
}

InsiStatusOnSave.propTypes = {
  status: PropTypes.oneOf(['PROVISOIRE', 'RECUPEREE', 'QUALIFIEE']),
};

InsiStatusOnSave.defaultProps = {
  status: undefined,
};
